import { sx } from '../../../lib/sx'
import type { Vals } from '../../../demo/vals'

export function UpgradeTerm({ v }: { v: Vals }) {
  return (
    <div style={sx("position:absolute;inset:0;padding:56px 20px 34px;display:flex;flex-direction:column")}>
      <button onClick={v.backToSub} style={sx("width:36px;height:36px;flex:none;border-radius:var(--radius-full);border:none;background:var(--bg-tertiary);cursor:pointer;display:flex;align-items:center;justify-content:center;margin-bottom:14px")}>
        <span style={sx("width:18px;height:18px;background:var(--text-primary);-webkit-mask:url(/assets/icons/arrow-left.svg) center/contain no-repeat;mask:url(/assets/icons/arrow-left.svg) center/contain no-repeat")} />
      </button>
      <span style={sx("font-size:var(--fs-5xl);font-weight:var(--fw-bold);letter-spacing:var(--ls-sm);line-height:34px;margin-bottom:6px")}>
        How long for?
      </span>
      <span style={sx("font-size:var(--fs-sm);line-height:20px;color:var(--text-secondary);margin-bottom:20px")}>
        All 5 accounts are charged upfront — not per person as they join.
      </span>
      <div style={sx("display:flex;flex-direction:column;gap:10px")}>
        <button onClick={v.pickUpM} style={sx(`text-align:left;padding:16px;border-radius:var(--radius-lg);border:2px solid ${v.upMBorder};background:${v.upMBg};color:var(--text-primary);font-family:inherit;cursor:pointer;display:flex;justify-content:space-between;align-items:center;gap:12px;transition:all 150ms var(--ease-out)`)}>
          <span style={sx("display:flex;flex-direction:column;gap:3px")}>
            <span style={sx("font-size:var(--fs-md);font-weight:var(--fw-medium)")}>
              1 month
            </span>
            <span style={sx("font-size:var(--fs-xs);color:var(--text-secondary)")}>
              {v.upMTotal}
            </span>
          </span>
          <span style={sx("text-align:right;display:flex;flex-direction:column;gap:2px")}>
            <span style={sx("font-size:var(--fs-lg);font-weight:var(--fw-bold)")}>
              {v.upMPrice}
            </span>
            <span style={sx("font-size:var(--fs-2xs);color:var(--text-secondary)")}>
              {v.upMSave}
            </span>
          </span>
        </button>
        <button onClick={v.pickUpY} style={sx(`text-align:left;padding:16px;border-radius:var(--radius-lg);border:2px solid ${v.upYBorder};background:${v.upYBg};color:var(--text-primary);font-family:inherit;cursor:pointer;display:flex;justify-content:space-between;align-items:center;gap:12px;transition:all 150ms var(--ease-out)`)}>
          <span style={sx("display:flex;flex-direction:column;gap:3px")}>
            <span style={sx("font-size:var(--fs-md);font-weight:var(--fw-medium)")}>
              1 year
            </span>
            <span style={sx("font-size:var(--fs-xs);color:var(--text-secondary)")}>
              {v.upYTotal}
            </span>
          </span>
          <span style={sx("text-align:right;display:flex;flex-direction:column;gap:2px")}>
            <span style={sx("font-size:var(--fs-lg);font-weight:var(--fw-bold)")}>
              {v.upYPrice}
            </span>
            <span style={sx("font-size:var(--fs-2xs);color:var(--text-secondary)")}>
              {v.upYSave}
            </span>
          </span>
        </button>
        <button onClick={v.pickUp2Y} style={sx(`text-align:left;padding:16px;border-radius:var(--radius-lg);border:2px solid ${v.up2Border};background:${v.up2Bg};color:var(--text-primary);font-family:inherit;cursor:pointer;display:flex;justify-content:space-between;align-items:center;gap:12px;transition:all 150ms var(--ease-out)`)}>
          <span style={sx("display:flex;flex-direction:column;gap:3px")}>
            <span style={sx("font-size:var(--fs-md);font-weight:var(--fw-medium)")}>
              2 years
            </span>
            <span style={sx("font-size:var(--fs-xs);color:var(--text-secondary)")}>
              {v.up2Total}
            </span>
          </span>
          <span style={sx("text-align:right;display:flex;flex-direction:column;gap:2px")}>
            <span style={sx("font-size:var(--fs-lg);font-weight:var(--fw-bold)")}>
              {v.up2Price}
            </span>
            <span style={sx("font-size:var(--fs-2xs);color:var(--text-secondary)")}>
              {v.up2Save}
            </span>
          </span>
        </button>
      </div>
      <div style={sx("margin-top:auto;display:flex;flex-direction:column;gap:8px")}>
        <span style={sx("font-size:var(--fs-2xs);line-height:15px;color:var(--text-secondary);text-align:center")}>
          All 5 accounts are included from day one — invite people whenever you like.
        </span>
        <button onClick={v.openCheckout} style={sx("height:52px;border-radius:var(--radius-full);border:none;background:var(--bg-accent);color:#fff;font-family:inherit;font-size:var(--fs-md);font-weight:var(--fw-medium);cursor:pointer")}>
          Continue
        </button>
      </div>
    </div>
  )
}
